'use client';

import { useMediaQuery } from '@zg-rentals/react-hooks';

// Constellation's `lg` breakpoint (48em = 768px at default font size). Kept em-based so it
// flips at the same width as the Panda CSS `lg` condition even under browser font scaling.
const MIN_LG = '(min-width: 48em)';

export function useIsDesktop(): boolean {
  return useMediaQuery(MIN_LG);
}
